import { render } from "./LayoutView.vue?vue&type=template&id=b2b95cd4&scoped=true"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"

import "./LayoutView.vue?vue&type=style&index=0&id=b2b95cd4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b95cd4"]])

export default __exports__